var React = require('react');

function RectangleMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0H182V510L0 519.5V0Z","fill":"#6F16FF"}));
}

RectangleMobile.defaultProps = {"width":"181","height":"520","viewBox":"0 0 181 520","fill":"none"};

module.exports = RectangleMobile;

RectangleMobile.default = RectangleMobile;
